import React, {useCallback, useState, useEffect} from "react"
import {useGallery} from 'store/gallery'
import {generate_uuid} from '../../lib/helpers'

function ImageGalleryField(props) {
    const {field, form} = props
    const [selected, setSelected] = useState([]);
    const {toggleGallery, dispatch} = useGallery();

    const handleChangeFieldValue = useCallback((selected) => {
        form.setFieldValue(field.name, selected.map(item => item.id))
    }, [field.name, form]);

    useEffect(() => {
        if (Array.isArray(field.value) && field.value.length > 0 && field.value.every(i => typeof i === "object")) {
            const selectedItems = field.value.map(i => ({uuid: generate_uuid(), id: i.id, url: i.url}))
            setSelected(selectedItems);
            handleChangeFieldValue(selectedItems)
        }
    }, [field.value, handleChangeFieldValue])

    return (
        <>
            <div className="w-full flex flex-col gap-y-2">
                <label
                    className="w-full block uppercase text-gray-700 text-xs font-bold my-2"
                    htmlFor="grid-password"
                >
                    {props.label}
                </label>
                <div className="w-full flex justify-start gap-x-3">
                    {selected && selected.length > 0 && selected.map(item => (
                        <div
                            key={item.uuid}
                            className="relative flex cursor-pointer w-1/6 justify-center items-center h-32 bg-gray-50 border-2 hover:bg-gray-200"
                            onClick={() => {
                                dispatch(toggleGallery((file) => {
                                    const selectedItems = [...selected.filter(i => i.uuid !== item.uuid), {
                                        uuid: generate_uuid(),
                                        id: file.id,
                                        url: file.url
                                    }];
                                    setSelected(selectedItems)
                                    handleChangeFieldValue(selectedItems)
                                    dispatch(toggleGallery());
                                }))
                            }}>
                            <img alt="تصویر انتخاب‌شده" className="w-full h-full" src={item.url}/>
                            <span className="absolute fa fa-plus transform rotate-45 z-10 right-1 top-2 text-red-500"
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      const selectedItems = [...selected.filter(i => i.uuid !== item.uuid)];
                                      setSelected(selectedItems)
                                      handleChangeFieldValue(selectedItems)
                                  }}></span>
                        </div>
                    ))}
                    <div
                        className="flex cursor-pointer w-1/6 justify-center items-center h-32 bg-gray-50 border-2 hover:bg-gray-200"
                        onClick={() => {
                            dispatch(toggleGallery((file) => {
                                const selectedItems = [...selected, {
                                    uuid: generate_uuid(),
                                    id: file.id,
                                    url: file.url
                                }];
                                setSelected(selectedItems)
                                handleChangeFieldValue(selectedItems)
                                dispatch(toggleGallery());
                            }))
                        }}>
                        <span className="fa fa-plus text-green-600"></span>
                    </div>

                </div>
            </div>
        </>
    );
}

export default ImageGalleryField
